import { useHistory } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Backdrop from '@mui/material/Backdrop';

import { changeUrlGivenCurrentQueryParams } from 'components/LinkWithQuery';

import { useStyles } from './HeaderButtonsModal.styles';

const HeaderButtonsModal = ({ onClickAway = null, leftButton, title, rightButton, content }) => {
  const theme = useTheme();
  const { classes } = useStyles({ theme });

  const history = useHistory();
  const handleClickAway = () => {
    changeUrlGivenCurrentQueryParams(history, { showDialog: null });
    onClickAway?.();
  };

  return (
    <div className={classes.root}>
      <div className={classes.buttons}>
        <div className={classes.buttonLeft}>{leftButton}</div>
        {title && (
          <div className={classes.center}>
            <span className={classes.navigationTitle}>{title}</span>
          </div>
        )}
        <div className={classes.buttonRight}>{rightButton}</div>
      </div>
      <Divider />
      <div className={classes.contentContainer}>{content}</div>
      <Backdrop sx={{ '&.MuiBackdrop-root': { zIndex: -1 } }} open={true} onClick={handleClickAway} />
    </div>
  );
};

export default HeaderButtonsModal;
